import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import { Reveal } from "@/components/site/motion";
import { useLang } from "@/LanguageContext";
import { LEGAL } from "@/legalContent";

export default function LegalPage({ type }) {
  const { t, lang } = useLang();
  const doc = LEGAL[lang][type];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [type]);

  return (
    <div className="grain relative bg-navy min-h-screen">
      <Navbar />
      <main className="pt-32 pb-24">
        <div className="mx-auto max-w-3xl px-6 lg:px-12">
          <Reveal>
            <Link
              to="/"
              data-testid="back-home"
              className="inline-flex items-center gap-2 text-sm text-white/60 hover:text-gold transition-colors duration-300"
            >
              <ArrowLeft size={16} /> {t.footer.backHome}
            </Link>
          </Reveal>

          <Reveal delay={0.05}>
            <h1 className="font-serif text-4xl sm:text-5xl text-white mt-8 tracking-[-0.01em]">{doc.title}</h1>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="text-gold/70 text-xs uppercase tracking-[0.3em] mt-4">{doc.updated}</p>
          </Reveal>
          <Reveal delay={0.14}>
            <p className="text-white/65 leading-relaxed mt-8">{doc.intro}</p>
          </Reveal>

          <div className="mt-14 space-y-12">
            {doc.sections.map((s, i) => (
              <Reveal key={i} y={30}>
                <section data-testid={`legal-section-${i}`}>
                  <h2 className="font-serif text-xl sm:text-2xl text-white">{s.h}</h2>
                  {s.body &&
                    s.body.map((p, j) => (
                      <p key={j} className="text-white/60 leading-relaxed mt-4">{p}</p>
                    ))}
                  {s.list && (
                    <ul className="mt-5 space-y-3">
                      {s.list.map((li, j) => (
                        <li key={j} className="flex items-start gap-3 text-white/60">
                          <span className="mt-2.5 h-1 w-1 rounded-full bg-gold shrink-0" />
                          <span className="leading-relaxed">{li}</span>
                        </li>
                      ))}
                    </ul>
                  )}
                  {s.after && <p className="text-white/60 leading-relaxed mt-4">{s.after}</p>}
                </section>
              </Reveal>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
